import { createContext } from 'react';

export interface ProfileAccess {
  role: string;
  features: Set<string>;
  permissions: Set<string>;
  resources: Map<string, Set<string>>;
  subscription_start_date: string | null;
  subscription_end_date: string | null;
  subscription_active: boolean;
}

export const AccessContext = createContext<{
  access: ProfileAccess | null;
  isLoading: boolean;
  error: boolean;
}>({
  access: null,
  isLoading: true,
  error: false,
});
